module.exports = __webpack_public_path__ + "img/character_details.1fff0b56.png";